<template>
  <div class="home">
    <div class="top">
    </div>
    <div class="details">
      <div style="height: 20px"></div>
      <div>
        <el-tabs v-model="activeName" @tab-click="handleClick" style="width: 90%;margin-left: 5%">
          <el-tab-pane label="信息公示" name="first" style="min-height: 40rem">
            <div>
              <div class="title">
                信息公示
              </div>
              <div style="display: flex">
                <div class="name">INFORMATION</div>
                <div style="width: 70%">
                  <el-divider></el-divider>
                </div>
              </div>
              <div style="min-height: 25rem">
                <div  :class="['news',item.isHovered ? 'hover-shadow':'']" @click="toDetails(item)" v-for="item in profileList" :key="item.id" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
                  <div class="news_title"
                       :style="{
              fontSize :item.isHovered ? '21px':'',
              color:item.isHovered ? '#1196db':''
            }"
                       v-bind:title="item.title">{{item.title}}</div>
                  <div class="news_date"  :style="{
              color:item.isHovered ? '#1196db':''
            }">{{item.publishDate.substring(0,10)}}</div>
                </div>
              </div>
              <div style="width: 100%;text-align: center">
                <el-pagination
                    background
                    style="text-align: center"
                    layout="prev, pager, next"
                    :total="proTotal"
                    :current-page="queryProfile.pageNum"
                    :page-size="queryProfile.pageSize"
                    @current-change="handleCurrentChangePro">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="结果公示" name="second" >
            <div>
              <div class="title">
                结果公示
              </div>
              <div style="display: flex">
                <div class="name">RESULT PUBLICITY</div>
                <div style="width: 70%">
                  <el-divider></el-divider>
                </div>
              </div>
              <div style="min-height: 25rem">
                <div :class="['news',item.isHovered ? 'hover-shadow':'']" v-for="item in resultList" :key="item.id" @click="toDetails(item)" @mouseenter="changeShadow(item)" @mouseleave="changeShadow(item)">
                  <div  class="news_title"  :style="{
              fontSize :item.isHovered ? '21px':'',
              color:item.isHovered ? '#1196db':''
            }" v-bind:title="item.title">{{item.title}}</div>
                  <div class="news_date"  :style="{
              color:item.isHovered ? '#1196db':''
            }">{{item.publishDate.substring(0,10)}}</div>
                </div>
              </div>
              <div style="width: 100%;text-align: center">
                <el-pagination
                    background
                    style="text-align: center"
                    layout="prev, pager, next"
                    :total="resTotal"
                    :current-page="queryResult.pageNum"
                    :page-size="queryResult.pageSize"
                    @current-change="handleCurrentChangeRes">
                </el-pagination>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {getArticleList} from "@/api/article";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "index",
  data(){
    return {
      resTotal:undefined,
      proTotal:undefined,
      profileList:[],
      resultList:[],
      profileTotal:0,
      resultTotal:0,
      queryProfile:{
        pageNum: 1,
        pageSize: 10,
        status:true,
        category:4,
      },
      queryResult:{
        pageNum: 1,
        pageSize: 10,
        status:true,
        category:5,
      },
      activeName:'first',
    }
  },
  mounted() {
      this.getProList()
  },
  beforeRouteLeave(to, from, next) {
    // 保存滚动位置到 Vue Router 的 meta 字段
    if (this.$el) {
      from.meta.savedPosition = {
        x: window.pageXOffset,
        y: window.pageYOffset,
      };
    }
    next();
  },
  methods :{
    changeShadow(item) {
      item.isHovered = !item.isHovered;
    },
    handleCurrentChangePro(pageNum){
      this.queryProfile.pageNum=pageNum
      this.getProList()
    },
    handleCurrentChangeRes(pageNum){
      this.queryResult.pageNum=pageNum
      this.getResList()
    },
    handleClick(tab) {
      if(tab.name=='first'){
        this.profileList=[]
       this.getProList()
      }else if(tab.name=='second'){
        this.resultList=[]
        this.getResList()
      }
    },
    getProList(){
      getArticleList(this.queryProfile).then(res=>{
        const data =res.data.content
        for (let i = 0; i <data.length ; i++) {
          data[i].isHovered=false
        }
        this.proTotal=res.data.totalElements
        this.profileList=data
      })
    },
    getResList(){
      getArticleList(this.queryResult).then(res=>{
        const data =res.data.content
        for (let i = 0; i <data.length ; i++) {
          data[i].isHovered=false
        }
        this.resTotal=res.data.totalElements
        this.resultList=data
      })
    },

    toDetails(item){
      item.isHovered=false
      this.$router.push({path: "/tendering/details",query:{id :item.id}})
    }
  }
}
</script>

<style scoped>
.hover-shadow {
  /* 鼠标悬停时的阴影效果 */
  box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.1);
}
.news_date{
  text-align: center;
  width: 20%;
  cursor: pointer;
}
.news_title{
  text-align: left;
  cursor: pointer;
  width: 80%;
  overflow: hidden;
  font-weight: 400;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news{
  display: flex;
  width: 90%;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  font-weight: 100;
  height: 60px;
  border-bottom: 1px solid  #bfbfbf;
  margin-left: 5%;
}
.details{
  width: 70%;
  background-color: white;
  margin-left: 15%;
}
.home{
  padding-top: 4rem;
  width: 100%;
  background-color: #efefef;
}
.title {
  margin-top: 40px;
  height: 50px;
  width: 120px;
  font-weight: 700;
  font-size: 24px;
  color: white;
  background-color: #234C9C;
  display: flex;
  align-items: center;
  justify-content: center;
}
.name{
  font-family: 'Arial Normal', 'Arial', sans-serif;
  font-weight: 400;
  font-style: normal;
  width: 30%;
  color: #AAAAAA;
  font-size: 24px;
  margin-top: 10px;
}
</style>
